export class SocialLinks {
  facebook: string;
  twitter: string;
  linkedin: string;
  snapchat: string;
  instagram: string;
  tiktok: string;
}
